module.exports = __webpack_public_path__ + "assets/img/485b-mt.svg";